import { LEVEL, LEVEL_PROPERTIES } from '@/interfaces/level.interface'

// `features` only contains a geojson feature for a level that actually has geometry saved (the
// geojson endpoint has no entry at all for a level without one -- not a null-geometry placeholder).
// Iterating over `features` as the base therefore silently dropped every geometry-less level from
// the merged result, on top of whatever geometry it did have. Iterating over `properties` (every
// level belonging to this construction) instead, and falling back to the building's own footprint
// per-level, keeps every level present.
export default function mergeLevels(
  buildingGeometry: GeoJSON.Polygon | GeoJSON.MultiPolygon,
  features: LEVEL[],
  properties: LEVEL_PROPERTIES[]
): LEVEL[] {
  const featureByLevelId = new Map(
    features.map((feature) => [feature.properties.belongsToId, feature])
  )
  return properties.map((levelProperties) => {
    const feature = featureByLevelId.get(levelProperties.id)
    const mergedProperties = { ...feature?.properties, ...levelProperties }
    if (!feature?.geometry) {
      mergedProperties.geometryFromBuilding = true
    }
    return {
      type: feature?.type ?? 'Feature',
      geometry: feature?.geometry ?? buildingGeometry,
      id: levelProperties.id,
      properties: { ...mergedProperties, belongsToId: levelProperties.id }
    }
  })
}
